import React from 'react';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 24,
  color = 'var(--cab-violet)',
  className = ''
}) => {
  return (
    <div className={`cab-loading-container ${className}`}>
      <div className="cab-loading-spinner" />
      <style>{`
        .cab-loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }
        .cab-loading-spinner {
          width: ${size}px;
          height: ${size}px;
          border: 3px solid rgba(54, 23, 119, 0.1);
          border-top-color: ${color};
          border-radius: 50%;
          animation: cab-spin 1s linear infinite;
        }
        @keyframes cab-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
